import { GraphQLResult } from "@aws-amplify/api-graphql";

import {
  AddCoverageDetails,
  AddCovertreeCoverageMutation,
  AddCovertreeCoverageMutationVariables,
  AddExternalCoverageMutation,
  AddExternalCoverageMutationVariables,
  CancelTllCoverageMutation,
  CancelTllCoverageMutationVariables,
  Coverage,
  GetCtCoverageDetailsMutation,
  GetCtCoverageDetailsMutationVariables,
  GetCTCoverageDetailsResponse,
  GetManufacturersQuery,
  GetManufacturersQueryVariables,
  IssueTLLForResidentMutation,
  IssueTLLForResidentMutationVariables,
  Resident,
} from "@graphql/api";
import { api } from "@redux/api";
import { Tags } from "@redux/types";
import { OperationName } from "@redux/utils/graphqlBaseOperation";

export const coveragesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCtCoverageDetails: build.mutation<
      GetCTCoverageDetailsResponse | undefined,
      GetCtCoverageDetailsMutationVariables
    >({
      query: (data) => {
        const operationName: OperationName = "getProofOfCoverageDetails";

        return {
          operationName,
          data,
        };
      },
      transformResponse: (
        response: GraphQLResult<GetCtCoverageDetailsMutation>
      ) => response.data?.getCtCoverageDetails,
    }),
    addCovertreeCoverage: build.mutation<
      AddCoverageDetails | undefined,
      AddCovertreeCoverageMutationVariables
    >({
      query: (data) => {
        const operationName: OperationName = "addCovertreeCoverage";

        return {
          operationName,
          data,
        };
      },
      transformResponse: (
        response: GraphQLResult<AddCovertreeCoverageMutation>
      ) => response.data?.addCovertreeCoverage,
      invalidatesTags: (_res, _err, arg) => [
        { type: Tags.Resident, id: arg.residentId },
      ],
    }),
    issueTLLForResident: build.mutation<
      Resident,
      IssueTLLForResidentMutationVariables
    >({
      query: (data) => {
        const operationName: OperationName = "issueTLLForResident";

        return {
          operationName,
          data,
        };
      },
      transformResponse: (
        response: GraphQLResult<IssueTLLForResidentMutation>
      ) => response.data?.issueTLLForResident,
      invalidatesTags: (_res, _err, arg) => [
        { type: Tags.Resident, id: arg.id },
      ],
    }),
    cancelTllCoverage: build.mutation<
      Coverage | undefined,
      CancelTllCoverageMutationVariables
    >({
      query: (data) => {
        const operationName: OperationName = "cancelTllCoverage";

        return {
          operationName,
          data,
        };
      },
      transformResponse: (response: GraphQLResult<CancelTllCoverageMutation>) =>
        response.data?.cancelTllCoverage,
      invalidatesTags: (_res, _err, arg) => [
        { type: Tags.Resident, id: arg.residentId },
      ],
    }),
    addExternalCoverage: build.mutation<
      AddCoverageDetails | undefined,
      AddExternalCoverageMutationVariables
    >({
      query: (data) => {
        const operationName: OperationName = "addExternalCoverage";

        return {
          operationName,
          data,
        };
      },
      transformResponse: (
        response: GraphQLResult<AddExternalCoverageMutation>
      ) => response.data?.addExternalCoverage,
      invalidatesTags: (_res, _err, arg) => [
        { type: Tags.Resident, id: arg.residentId },
      ],
    }),
    getManufacturers: build.query<string[], GetManufacturersQueryVariables>({
      query: (data) => {
        const operationName: OperationName = "getManufacturers";

        return {
          operationName,
          data,
        };
      },
      transformResponse: (response: GraphQLResult<GetManufacturersQuery>) =>
        response.data?.getParameters,
    }),
  }),
});

export const {
  useGetCtCoverageDetailsMutation,
  useAddCovertreeCoverageMutation,
  useIssueTLLForResidentMutation,
  useCancelTllCoverageMutation,
  useAddExternalCoverageMutation,
  useLazyGetManufacturersQuery,
} = coveragesApi;
